import React from 'react';
import { CTABand } from '../../components/CTABand';
export function TaekwondoNearMeFinalCTA() {
  return <CTABand headline="Storm Taekwondo Is Closer Than You Think" copy="24786 Crestview, Farmington Hills, MI 48335 — easily reached from Novi, Commerce, Livonia, Northville, Waterford and nearby Southeast Michigan." data-id="element-3401" />;
}